import { render, staticRenderFns } from "./OfferRedirects.vue?vue&type=template&id=e1822e74&"
import script from "./OfferRedirects.vue?vue&type=script&lang=ts&"
export * from "./OfferRedirects.vue?vue&type=script&lang=ts&"
import style0 from "./OfferRedirects.vue?vue&type=style&index=0&id=e1822e74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports